import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { OarTaskApi } from '../../apis/oar-task-api';
import type { OarTaskDataLoader } from '../oar-task-data-loader';
import type { OarTaskContent } from '../../types/oar-types';
import { OarParseStatus } from '../../types/oar-types';

/**
 * 任务基本信息加载器
 *
 * 负责加载 OAR 任务的基本信息，包括：
 * - PDF 文件信息
 * - 各部分的解析状态（header/table/body）
 */
@injectable()
export class TaskInfoLoader implements OarTaskDataLoader {
    readonly name = 'TaskInfo';

    constructor(
        @inject(OarTaskApi)
        private readonly _api: OarTaskApi,
    ) {}

    /**
     * 总是需要加载任务基本信息
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    shouldLoad(_state: OarTaskContent): boolean {
        return true;
    }

    /**
     * 加载任务基本信息
     */
    async load(taskId: string): Promise<Partial<OarTaskContent>> {
        const taskInfo = await this._api.getTaskInfo({
            path: { task_id: taskId },
        });

        return {
            oarPdfInfo: taskInfo.pdf_info ? {
                pdfUrl: taskInfo.pdf_info.pdf_url,
                pdfS3Key: taskInfo.pdf_info.s3_key,
                pdfFileName: taskInfo.pdf_info.file_name,
                pdfFileSize: taskInfo.pdf_info.file_size,
                uploadedAt: taskInfo.pdf_info.uploaded_at,
            } : undefined,
            oarHeaderParseStatus: taskInfo.header_parse_status as OarParseStatus,
            oarTableParseStatus: taskInfo.table_parse_status as OarParseStatus,
            oarBodyParseStatus: taskInfo.body_parse_status as OarParseStatus,
        };
    }
}
